module.exports = __webpack_public_path__ + "media/invite-a-friend/friends-on-phones-mobile-a88ba9fa.webp";